import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [openNav, setOpenNav] = useState(false);
  const [initialMobileState, setInitialMobileState] = useState(false);

  function handleHamburgerClick() {
    setInitialMobileState(true);
    setOpenNav(true);
  }

  return (
    <div className="relative">
      <header
        className="bg-[#2A3D19] px-4 py-0 flex justify-between items-center z-30 text-white"
        id="header"
      >
        <img
          src="https://res.cloudinary.com/druryt8ny/image/upload/v1700518851/rsnuvxsp8itnttc6hk9u.png"
          alt="logo"
          className="w-40 h-20 object-fit -translate-y-[5px] -translate-x-[2.5rem]"
        />

        {/* Desktop Nav */}

        <nav className="hidden md:block">
          <ul className="flex text-white">
            <li>
              <Link to="/" className="block px-4 py-4 font-semibold">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className="block px-4 py-4 font-semibold">
                About
              </Link>
            </li>
            <li>
              <Link to="/therapy" className="block px-4 py-4 font-semibold">
                Therapy
              </Link>
            </li>
            <li>
              <Link to="/community" className="block px-4 py-4 font-semibold">
                Community
              </Link>
            </li>
            <li>
              <Link to="/signin" className="block px-4 py-4 font-semibold">
                Sign In
              </Link>
            </li>
          </ul>
        </nav>
        <nav className="md:hidden">
          <div className="cursor-pointer">
            <img
              src="https://res.cloudinary.com/druryt8ny/image/upload/v1700520896/v3sawxrvwxt7xw7j4kqs.png"
              alt="hamburger"
              className={openNav ? "hidden" : "w-8 h-8 block"}
              onClick={handleHamburgerClick}
            />
            <img
              src="https://res.cloudinary.com/druryt8ny/image/upload/v1700517686/qbuitqhzwx51igphs0nk.png"
              alt="close-menu"
              className={openNav ? "w-8 h-8 block" : "hidden"}
              onClick={() => setOpenNav(false)}
            />
          </div>
        </nav>
      </header>

      {/* <div className="relative"> */}
      <ul
        className={
          openNav
            ? "bg-red-500 text-[#2A3D19] py-4 transform left-0 w-full absolute block z-20 slide-in md:hidden"
            : "slide-out -top-[100%] md:hidden"
        }
      >
        <li>
          <Link
            to="/"
            className="block py-4 text-center text-lg font-semibold border-b border-[#fff]"
          >
            Home
          </Link>
        </li>
        <li>
          <Link
            to="/about"
            className="block py-4 text-center text-lg font-semibold border-b border-[#fff]"
          >
            About
          </Link>
        </li>
        <li>
          <Link
            to="/therapy"
            className="block py-4 text-center text-lg font-semibold border-b border-[#fff]"
          >
            Therapy
          </Link>
        </li>
        <li>
          <Link
            to="/community"
            className="block py-4 text-center text-lg font-semibold border-b border-[#fff]"
          >
            Community
          </Link>
        </li>
        <li>
          <Link to="/" className="block pt-4 text-center text-lg font-semibold">
            Sign In
          </Link>
        </li>
      </ul>
      {/* </div> */}
    </div>
  );
};

export default Navbar;
